import React, { useState } from 'react';
import { BiCube } from 'react-icons/bi';
import "../assets/styles/Footer-Link-Content.css";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqData = [
    {
      question: "What is your return and refund policy?",
      answer: (
        <div>
          <p>Our return and refund policy includes:</p>
          <ul>
            <li>Returns accepted within 24 hours of delivery</li>
            <li>Items must be unused and in original condition</li>
            <li>Contact customer service with your order number</li>
            <li>Refunds processed within 5-7 business days after inspection</li>
          </ul>
        </div>
      )
    },
    {
      question: "How do you handle shipping and delivery?",
      answer: (
        <div>
          <p>Our shipping process:</p>
          <ul>
            <li>Orders dispatched within 3-4 working days</li>
            <li>Tracking number provided via email</li>
            <li>Delivery times vary by location</li>
            <li>Shipping costs shown at checkout</li>
          </ul>
        </div>
      )
    },
    {
      question: "What are your payment and security measures?",
      answer: (
        <div>
          <p>We ensure secure payments through:</p>
          <ul>
            <li>All major credit and debit cards accepted</li>
            <li>Industry-standard encryption</li>
            <li>Secure payment gateway</li>
            <li>No storage of financial details on our servers</li>
          </ul>
        </div>
      )
    },
    {
      question: "How do you protect customer privacy?",
      answer: (
        <div>
          <p>We protect your privacy by:</p>
          <ul>
            <li>Collecting information only for order processing</li>
            <li>Never sharing data with unauthorized third parties</li>
            <li>Providing access to your personal information</li>
            <li>Allowing you to correct or delete your data</li>
          </ul>
        </div>
      )
    },
    {
      question: "What is your quality assurance policy?",
      answer: (
        <div>
          <p>Our quality assurance includes:</p>
          <ul>
            <li>Strict quality control before shipping</li>
            <li>Quality guarantee with each purchase</li>
            <li>Full refund for damaged items</li>
            <li>Free replacement shipping for defective products</li>
          </ul>
        </div>
      )
    },
    {
      question: "Do you offer customization services?",
      answer: (
        <div>
          <p>Our customization options include:</p>
          <ul>
            <li>Personalized engravings</li>
            <li>Size adjustments</li>
            <li>Custom designs</li>
            <li>Note: Custom items are non-returnable unless defective</li>
          </ul>
        </div>
      )
    },
    {
      question: "How can I contact customer support?",
      answer: (
        <div>
          <p>Reach our customer service team:</p>
          <ul>
            <li>Email: example@gmail.com</li>
            <li>Phone: 9876543210</li>
            <li>Response time: Within 24 hours</li>
            <li>Business hours: Monday to Friday</li>
          </ul>
        </div>
      )
    },
    {
      question: "What are your terms of service?",
      answer: (
        <div>
          <p>Key terms include:</p>
          <ul>
            <li>Prices locked in at order confirmation</li>
            <li>Right to refuse service reserved</li>
            <li>Website content protected by copyright</li>
            <li>Terms subject to change with notice</li>
          </ul>
        </div>
      )
    }
  ];

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="footer-link-content">
      <h1>FQA's</h1>

      <p>Varnamika is committed to protecting the privacy and security of your personal information. This Privacy Policy describes how we collect, use, and disclose personal information when you visit our website or make a purchase from our jewelry store.</p>

      <div className="faq-container">
        {faqData.map((faq, index) => (
          <div key={index} className="faq-item">
            <div
              className="faq-question"
              onClick={() => toggleAccordion(index)}
            >
              <span className="faq-icon">
                <BiCube />
              </span>
              {faq.question}
              <span className="dropdown-arrow">▼</span>
            </div>
            {openIndex === index && (
              <div className="faq-answer">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;